import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { editDocumentsInAttachesExts } from 'reactApp/appHelpers/featuresHelpers/features/editDocumentsInAttachesExts';
import { hasViewerMenu } from 'reactApp/appHelpers/featuresHelpers/features/viewerMenu';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { dispatch } from 'reactApp/react-into-toolkit-block-wrapper/renderComponentInExternalDom';
import { put } from 'redux-saga/effects';

const EDIT_TOOLTIP_ID = 'edit-documents-in-attaches-tooltip';
const PROMO_SHOW_COUNT = `${EDIT_TOOLTIP_ID}-count`;
const MAX_SHOW_COUNT = 3;
const PERIOD_IN_DAYS = 30;

export function* initEditDocumentsInAttachesTooltip() {
    const isViewerMenuInAttaches = hasViewerMenu(EStorageType.attaches);
    const promoClosedByUser = storeHelper.getValue(EDIT_TOOLTIP_ID);

    /**
     * Не показываем промо:
     * - Для старого меню на аттачах
     * - Для автотестов
     * - Если пользователь закрыл промо вручную
     * - Если список расширений для показа пустой
     */
    if (!isViewerMenuInAttaches || IS_AUTO_TEST_HIDE || promoClosedByUser || editDocumentsInAttachesExts.length === 0) {
        return;
    }

    const showCount: number = storeHelper.getValue(PROMO_SHOW_COUNT) || 0;
    const periodPassed = storeHelper.isPassed(PROMO_SHOW_COUNT, { daysCount: PERIOD_IN_DAYS });

    /**
     * Если НЕ прошло 30 дней с момента последнего показа
     */
    if (showCount && showCount > MAX_SHOW_COUNT && !periodPassed) {
        return;
    }

    /**
     * Если прошло 30 дней с момента последнего показа, то
     */
    if (periodPassed) {
        storeHelper.clearStore(PROMO_SHOW_COUNT);
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.editDocumentsInAttachesTooltip,
            promoId: EDIT_TOOLTIP_ID,

            onClick: () => {
                storeHelper.markAsShown(EDIT_TOOLTIP_ID);
                storeHelper.markAsShown(PROMO_SHOW_COUNT, MAX_SHOW_COUNT + 1);
            },

            /**
             * Кикаем промо из очереди, если у нас недоступно редактирование
             */
            onEditDisabled: () => {
                dispatch(removePromo(EPromoType.editDocumentsInAttachesTooltip));
            },

            onShow: () => {
                storeHelper.markAsShown(PROMO_SHOW_COUNT, showCount + 1);
                dispatch(promoShown(EPromoType.editDocumentsInAttachesTooltip));
            },

            onClose: () => {
                dispatch(removePromo(EPromoType.editDocumentsInAttachesTooltip));
            },

            onCrossClose: () => {
                storeHelper.markAsShown(EDIT_TOOLTIP_ID);
                storeHelper.markAsShown(PROMO_SHOW_COUNT, MAX_SHOW_COUNT + 1);
            },
        })
    );
}
